import { SchemeProvider } from '@osmosis/react-ui/context/SchemeContext';
import { Scheme } from '@osmosis/shared/styles';
import React, { ReactNode } from 'react';
import { IntlProvider } from 'react-intl';
import { QueryClient, QueryClientProvider } from 'react-query';
import { LazyMotion } from 'motion/react';

const loadFeatures = () =>
  import('../../lib/motionFeatures').then((res) => res.default);

type Props = {
  children: ReactNode;
  theme?: Scheme;
  withIntl?: boolean;
};

const queryClient = new QueryClient();
/**
 * Wrapper for composer admin.
 */
const AdminWrapper = (props: Props) => {
  const { children, withIntl = true } = props;
  return (
    <LazyMotion strict features={loadFeatures}>
      <SchemeProvider>
        <QueryClientProvider client={queryClient}>
          {withIntl ? (
            <IntlProvider locale="en"> {children} </IntlProvider>
          ) : (
            children
          )}
        </QueryClientProvider>
      </SchemeProvider>
    </LazyMotion>
  );
};

export default AdminWrapper;
